// /opt/isp_erp/frontend/src/utils/mensajesError.js
const CAMPOS = {
  email: 'Correo', identificacion: 'Cédula/RUC', tipo_identificacion: 'Tipo de identificación', nombres: 'Nombres',
  apellidos: 'Apellidos', telefono: 'Teléfono', direccion: 'Dirección', ciudad: 'Ciudad', servicio: 'Servicio', plan: 'Plan',
};

/** Convierte el error de una petición en un texto legible (el servidor a veces devuelve una lista de errores en inglés). */
export const mensajeError = (error, porDefecto = 'Ocurrió un error') => {
  const detalle = error && error.response && error.response.data ? error.response.data.detail : null;
  if (!detalle) return porDefecto;
  if (typeof detalle === 'string') return detalle;
  if (Array.isArray(detalle)) {
    return detalle.map((d) => {
      const campo = Array.isArray(d.loc) ? d.loc[d.loc.length - 1] : '';
      let msg = String(d.msg || '');
      if (/valid email|email address|@-sign/i.test(msg)) msg = 'no es un correo válido';
      else if (/field required/i.test(msg)) msg = 'es obligatorio';
      else if (/valid string/i.test(msg)) msg = 'debe ser texto';
      else if (/valid number|valid integer/i.test(msg)) msg = 'debe ser un número';
      else msg = msg.replace(/^Value error, /i, '');
      const nombre = CAMPOS[campo] || (typeof campo === 'string' ? campo : '');
      return nombre ? `${nombre}: ${msg}` : msg;
    }).join('\n');
  }
  if (typeof detalle === 'object') return detalle.error || detalle.message || porDefecto;
  return porDefecto;
};
